import { FormFieldTypes } from "../../../data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";

export const accountManagementConfig = {
    columns: [
        {
            name: "Name",
            fieldName: "name",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Email Address",
            fieldName: "email",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true
            }
        },
    ],
};

export const AccountListFormData = {
    name: "accountListFormData",
    initialState: {
        name: ''
    },
    formFields: [
        {
            id: "name",
            lable: "Name",
            Field_Name: "Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "name",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-3 ",
            },
        },

    ],
    formSetting: {
        isViewOnly: false
    }
}


export const viewListDataForm = {
    name: "viewListDataForm",
    initialState: {
        name: "",
        email: "",
        roleId: null
    },
    formFields: [
        {
            id: "firstName",
            lable: "First Name",
            Field_Name: "First Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "firstName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 mb-3",
            },
        },
        {
            id: "lastName",
            lable: "Last Name",
            Field_Name: "Last Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "lastName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 mb-3",
            },
        },
        {
            id: "email",
            lable: "Email",
            Field_Name: "Email",
            fieldType: FormFieldTypes.INPUT,
            dataField: "email",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 mb-3",
            },
        },
        {
            id: "roleId",
            lable: "Role",
            Field_Name: "Role",
            fieldType: FormFieldTypes.SELECT,
            dataField: "roleId",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 mb-3",
            },
        },

    ],
    formSetting: {
        isViewOnly: false
    }
}

export const passwordResetFormData = {
    name: "passwordResetForm",
    initialState: {
        name: "",
        email: "",
        roleId: null
    },
    formFields: [
      
        {
            id: "Update Password",
            lable: "",
            Field_Name: "Update Password",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "Update Password",
            fieldSetting: {
              formTitle: "Update Password",
            },
            style: {
              containerCss: "main-sub-title mt-5 mb-2",
            },
          },
        {
            id: "oldPassword",
            lable: "Old Password",
            Field_Name: "Old Password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "oldPassword",
            fieldSetting: {
                placeholder: "",
            },
            validation: [{ type: "require" }, { type: "password" }],
            style: {
                containerCss: "col-lg-12 mb-3"
            }
        },
        {
            id: "newPassword",
            lable: "New Password",
            Field_Name: "New Password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "newPassword",
            fieldSetting: {
                placeholder: "",
            },
            validation: [{ type: "require" }, { type: "password" }],
            style: {
                containerCss: "col-lg-12 mb-3"
            }
        },
        {
            id: "confirmNewPassword",
            lable: "Confirm New Password",
            Field_Name: "Confirm New Password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "confirmNewPassword",
            fieldSetting: {
                placeholder: "",
            },
            style: {
                containerCss: "col-lg-12 mb-3"
            },
            validation: [{ type: "require" }, { type: "password" }]
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}
